module.exports = __webpack_public_path__ + "img/solar-panel.46c0df8d.svg";